import { UnlockProfileDetails } from '@aibees/elephant/components/unlock-profile-details';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { useContactDetailsEnrichmentDescriptionText } from '@aibees/elephant/hooks/people/use-contact-details-enrichment-description-text';
import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { TabContext } from '@mui/lab';
import { Divider, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { ConfigContent } from './components/config-content';
import { ContactDetailTabs } from './components/contact-detail-tabs';
import { useContactDetailsConfig, useContactDetailsData } from './context';
import * as Styled from './styles';
import * as SX from './sx';
import { type ContactDetailsProps as Props } from './types';

export const ContactDetails = memo(({ className }: Props) => {
  const { activeTab } = useContactDetailsConfig();
  const { unlockableItems, sortedItemsWithContentCheck } =
    useContactDetailsData();
  const { api } = usePersonReadDataContext();
  const descriptionText = useContactDetailsEnrichmentDescriptionText(api.data);

  return (
    <TabContext value={activeTab.toString()}>
      <Styled.Wrapper
        className={classnames('ContactDetails', className)}
        sx={SX.root}
        title={
          <Typography variant="body3" fontWeight={700} color="grey.700">
            Profile Insights
          </Typography>
        }
        icon="badge-outline"
        iconColor="primary.500"
        iconSize={20}
        headerPadding="normal"
        contentPadding="none"
      >
        <Stack gap={1.5}>
          {!!unlockableItems.length && (
            <Grid2 sx={SX.lastUpdate}>
              <Typography variant="body3" color="grey.500" fontWeight={400}>
                {descriptionText}
              </Typography>

              <UnlockProfileDetails />
            </Grid2>
          )}
          {sortedItemsWithContentCheck.length ? (
            <Stack gap={1.5}>
              <Stack>
                <ContactDetailTabs />
                <Divider />
              </Stack>

              <ConfigContent limitedItems={false} sx={SX.configContent} />
            </Stack>
          ) : (
            <Stack padding={1.5}>
              <Typography variant="body3" color="grey.500">
                There is no information yet
              </Typography>
            </Stack>
          )}
        </Stack>
      </Styled.Wrapper>
    </TabContext>
  );
});

ContactDetails.displayName = 'ContactDetails';
